export default "__VITE_ASSET__DPKM$Wci__"